import { Button } from "../../ui/Button";
import { Frame, Note, useWidgetText } from "../shared";
import type { WidgetProps } from "../types";

/** scene_button: runs one manual automation, with when it last ran. */
export function SceneButton({ widget, input, now, onAction, readOnly }: WidgetProps) {
  const fmt = useWidgetText();
  const id = widget.automation ?? "";
  const a = input.automations?.[id];
  const name = widget.title ?? a?.name ?? "";
  // The page asks before every run (P-231), so the widget's own `confirm` config is not read.
  const run = () => onAction?.({ kind: "automation", id });
  const state = !a?.enabled ? "read_only" : a.last_ran_at ? "normal" : "empty";
  return (
    <Frame widget={widget} state={state} label={name}>
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="font-medium text-gray-900">{name}</p>
          <Note>{a?.last_ran_at ? fmt.age(a.last_ran_at, now) : fmt.t("scene.never")}</Note>
          {a && !a.enabled && <Note>{fmt.t("scene.disabled")}</Note>}
        </div>
        <Button disabled={!a?.enabled || readOnly} onClick={run}>
          {fmt.t("scene.run")}
        </Button>
      </div>
    </Frame>
  );
}
